import {useMemo} from 'react';
import type {
  ResolvedDataFormPartConfiguration,
  StructureOperation,
} from 'schema/types';
import type {Part, PartAction} from 'schemaDefinition/types';
import {useDataFormConfigurationContext} from '../contexts';

type PartProps = Partial<Pick<Part | PartAction, 'type' | 'key' | 'name'>>;

const allStructureOperations: Array<StructureOperation> = [
  'add',
  'move',
  'delete',
];

export const useResolvedDataFormPartConfiguration = (
  part: PartProps | undefined,
): Partial<ResolvedDataFormPartConfiguration> => {
  const config = useDataFormConfigurationContext();

  return useMemo(() => {
    if (!part || part.type === 'expand') {
      return {
        ...config,
        hideStructureOperations: config.hideAllStructureOperations
          ? allStructureOperations
          : undefined,
      };
    }

    const partKey = part.key ?? part.name;
    const partConfig = partKey ? config.parts?.[partKey] : undefined;

    return {
      ...partConfig,
      showWhenReadonlyAndEmpty:
        partConfig?.showWhenReadonlyAndEmpty ??
        config.showWhenReadonlyAndEmpty ??
        false,
      hideStructureOperations: config.hideAllStructureOperations
        ? allStructureOperations
        : partConfig?.hideStructureOperations,
      suggest: partConfig?.suggest ?? config.suggest,
    };
  }, [config, part]);
};
